<template>
	<div id="app">
		<router-view :innerWidth="innerWidth"></router-view>
	</div>
</template>

<script>
import { defualtMeta } from '@/utils/meta';

export default {
	metaInfo: {
		title: '아이알리미 | 행복을 이어주는 안심알리미',
		meta: defualtMeta,
	},
	name: 'App',
	data() {
		return {
			innerWidth: window.innerWidth,
		};
	},
};
</script>

<style>
@import './assets/css/common.css';

* {
	color: #111;
}

#app {
	height: 100%;
}

.hidden {
	display: none !important;
}
</style>
